export function isInvest(account) {
    return account.domainDetails.domain === 'INVEST';
}
export function isManagedPortfolio(account) {
    return isInvest(account) && account.domainDetails.isManagedPortfolio;
}
//# sourceMappingURL=invest.js.map